// extracted by mini-css-extract-plugin
module.exports = {"spoilerControl":"SessionsList_spoilerControl__L0i5U","sessionDateInfo":"SessionsList_sessionDateInfo__EZkMC"};